import {
  createBrowserRouter,
  Navigate,
  Outlet,
  useNavigate,
} from "react-router-dom";
import Layout from "../layout";
import { useAppSelector } from "../_app";
import { useEffect } from "react";
import ProtectedRoute from "./ProtectedRoute";
import {
  CreatePasswordScreen,
  LeaveRecordTaken,
  LoginScreen,
  ResetPasswordScreen,
  UserProfile,
} from "../pages";
import { Signin } from "../pages/auth";
import EmailVerifyScreen from "../pages/auth/EmailVerifyScreen";
import AccessDenied from "../pages/auth/AccessDenied";
import EmployeePayslips from "../pages/employee-payslips/EmployeePayslips";
import EmployeeRequests from "../pages/employee-requests/EmployeeRequests";
import EditInfoUpdate from "../pages/employee-requests/EditInfoUpdate";
import LoginRequest from "../pages/auth/LoginRequestForm";
import Dashboard from "../pages/dashboard";
import PageNotFound from "../components/PageNotFound";
import ManageExpenseClaims from "../pages/dashboard/expense/ManageExpenseClaims";
import EmployeeExpenseClaims from "../pages/employee-expense/EmployeeExpenseClaims";
import ManageCompanyForEmployee from "../pages/employee-manage-company/ManageCompanyForEmployee";
import { EmployeeLeaveApproval } from "../pages/employee-leave-approval";
import EmployeeLeaveApprovalDetails from "../pages/employee-leave-approval/EmployeeLeaveApprovalDetails/EmployeeLeaveApprovalDetails";
import LeaveRecordTakenForEmployee from "../pages/dashboard/leave/LeaveRecordTakenForEmployee";

const EmployeePrivateRoute = ({ children }: { children: any }) => {
  const navigate = useNavigate();

  const user = useAppSelector((state) => state.user);

  useEffect(() => {
    if (user.email === "") {
      navigate("/");
    }
  }, [user.email]);

  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
};

export const employeeRouter = createBrowserRouter([
  {
    path: "/",
    element: <LoginScreen />,
  },
  {
    path: "/sign-in",
    element: <Signin />,
  },
  {
    path: "/password-resets",
    element: <ResetPasswordScreen />,
  },
  {
    path: "/email-verify",
    element: <EmailVerifyScreen />,
  },
  {
    path: "/password-resets/*",
    element: <CreatePasswordScreen />,
  },
  {
    path: "/data/request-form",
    element: <LoginRequest />,
  },

  {
    path: "/dashboard",
    element: (
      <EmployeePrivateRoute>
        <Dashboard />
      </EmployeePrivateRoute>
    ),
    children: [
      {
        path: "payslips",
        element: <EmployeePayslips />,
      },
      {
        path: "expense-claims",
        element: <EmployeeExpenseClaims />,
      },
       {
            path: "approve",
            element: <Outlet />,
            children: [
              {
                path: "",
                element: <EmployeeLeaveApproval />
              },
              {
                path: "details",
                element: <EmployeeLeaveApprovalDetails />
              }
            ]
          },
      {
        path: "requests",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <EmployeeRequests />,
          },
          {
            path: "leave",
            element: <LeaveRecordTakenForEmployee />,
          },
          {
            path: "info",
            element: <EditInfoUpdate />,
          },
        ],
      },
      {
        path: "user-profile",
        element: <UserProfile />,
      },
      {
        path: "access-denied",
        element: <AccessDenied />,
      },
      {
        path: "manage-company",
        children: [
          {
            path: "",
            element: <ManageCompanyForEmployee />,
          },
          // {
          //   path: "deactivate",
          //   element: <DeactivateCompany />
          // },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <PageNotFound />, // Show 404 for any other unknown routes
  },
]);
